/* istanbul ignore file */
import { useKernelApi, usePeopleManagementApi } from 'infrastructure/api';
import { FormFieldsData } from 'framework/form';
import employeeHelthcheckValidation from './form/employeeHelthcheckValidation';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';

const useEmployeeHealthcheckService = () => {
  const { sendPatchRequest, sendPostRequest } = usePeopleManagementApi();
  const { sendPostRequest: sendKernalPostRequest } = useKernelApi();
  const employeeId = useEmployeeId();

  const create = async (data: FormFieldsData) => {
    // This request in "/dashboard" only to get retentionRiskId. If retentionRisk data will be awailable in Employee entity, we can use it directly
    const resDashboard = await sendPostRequest('/employees/dashboard/search', {
      pageNumber: 0,
      pageSize: 100,
      sort: {
        createdAt: 'DESC',
      },
      filter: {
        searchString: { ct: employeeId },
      },
    });
    const response = await resDashboard.json();
    const riskId = response.result && response.result.length > 0 ? response.result[0].retentionRiskId : null;

    // sendPatchRequest to create healthcheck itself and noteCreationResult to create note about healthcheck which will be displayed in timeline
    await sendPatchRequest(`/retention-risks/${riskId}/healthcheck`, { date: data.date });
    const noteCreationResult = await sendKernalPostRequest(`/employees/${employeeId}/notes`, {
      attachmentsIds: [],
      noteText: `<p><strong>Healthcheck</strong><br><br><strong>Date</strong>: ${data.date}<br><strong>Description</strong>: ${data.description}</p>`,
      employeeId,
    });

    const result = await noteCreationResult.json();
    return result.info || result;
  };

  return {
    getValidationSchema: () => Promise.resolve(employeeHelthcheckValidation),
    create,
  };
};

export default useEmployeeHealthcheckService;
